import { Enum } from 'enumify';

export class Domeneobjekt {
	static dybdekopier(objekt) {
		if (objekt == null || typeof objekt !== 'object') {
			return objekt;
		}
		if (objekt instanceof Date) {
			var kopi = new Date();
			kopi.setTime(objekt.getTime());
			return kopi;
		}
		if (objekt instanceof Array) {
			return objekt.map(Domeneobjekt.dybdekopier);
		}
		if (objekt instanceof Enum) {
			return objekt.constructor[objekt.name];
		}
		if (objekt instanceof Domeneobjekt) {
			return objekt.kopier();
		}
		if (objekt instanceof Object) {
			var kopi = {};
			Object.keys(objekt).forEach(function (felt) {
				if (objekt.hasOwnProperty(felt)) {
					kopi[felt] = Domeneobjekt.dybdekopier(objekt[felt]);
				}
			});
			return kopi;
		}
		return JSON.parse(JSON.stringify(objekt));
	}

	kopier() {
		var kopi = new this.constructor();
		Object.keys(this).forEach((felt) => {
			if (this.hasOwnProperty(felt)) {
				kopi[felt] = Domeneobjekt.dybdekopier(this[felt]);
			}
		});
		return kopi;
	}

	set(felt, verdi) {
		var kopi = this.kopier();
		kopi[felt] = verdi;
		return kopi;
	}

	add(felt, verdi) {
		if (this[felt] === undefined) {
			this[felt] = [];
		} else if (!(this[felt] instanceof Array)) {
			throw `${this.constructor.name}.${felt} er ikke ei liste.`;
		}
		var kopi = this.kopier();
		kopi[felt].push(verdi);
		return kopi;
	}
}
